import React, { FC } from "react";

import { StyledCategoryCard } from "./styled";

type CategoryCardProps = {
    id: string;
    name: string;
    icon: React.ReactElement;
    count: number;
    testPrefix: string;
    onClick: () => void;
};

const CategoryCard: FC<CategoryCardProps> = ({ id, name, count, icon, testPrefix, onClick }) => {
    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            onClick();
        }
    };
    return (
        <StyledCategoryCard
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            data-testid={`${testPrefix}-${id}`}
            onClick={onClick}
        >
            <div className="infos">
                <div className="count">{count}</div>
                <div className="name">{name}</div>
            </div>

            {icon}
        </StyledCategoryCard>
    );
};

export default CategoryCard;
